import { client } from '@/api/client';

// Shared by StepCDLMedical.jsx (onboarding) and DriverProfile.jsx (My
// Profile) -- base64-encodes an uploaded CDL/Medical Card photo or PDF
// and sends it to the parseDriverCredential edge function for AI
// extraction. Returns the extracted field object, or null if nothing
// usable came back (the edge function already surfaced a toast-worthy
// error string in that case, which callers may show themselves).
export async function extractDriverCredential(file, documentType) {
  const isImage = file.type.startsWith('image/');
  const base64 = await new Promise((res, rej) => {
    const reader = new FileReader();
    reader.onload = () => res(reader.result.split(',')[1]);
    reader.onerror = rej;
    reader.readAsDataURL(file);
  });
  // The edge function always answers 200 (even on a handled failure) with
  // { data: {...} | null, error?: string } -- it never throws for an
  // expected failure mode (missing API key, nothing extractable, etc.),
  // only client.functions.invoke's own network-level errors do.
  return client.functions.invoke('parseDriverCredential', {
    pdfBase64: base64,
    mediaType: file.type || (isImage ? 'image/jpeg' : 'application/pdf'),
    isImage,
    documentType,
  });
}
